<template>
  <div
    v-for="(item, k) in content"
    :key="k"
    ref="messageRefs"
    :class="[
      ' w-4/5 wysiwyg',
      role === 'user' ? 'bg-accent-500 text-white ml-auto p-4 rounded-lg shadow-sm' : 'mr-auto'
    ]">
    <vue-markdown :source="linkify(item.text)" :options="markdownOptions" />
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-render'

export default {
  components: { VueMarkdown },
  props: {
    role: {
      type: String,
      required: true
    },
    content: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      markdownOptions: {
        linkify: true
      }
    }
  },
  updated() {
    this.interceptInternalLinks()
  },
  mounted() {
    this.interceptInternalLinks()
  },
  methods: {
    linkify(text) {
      if (!text) return ''
      return text.replace(/(?<!\]\()(https?:\/\/[^\s)>\]]+)/g, '[$1]($1)')
    },
    interceptInternalLinks() {
      const refs = this.$refs.messageRefs
      if (!refs) return

      const elements = Array.isArray(refs) ? refs : [refs]
      elements.forEach((el) => {
        Array.from(el.getElementsByTagName('a')).forEach((anchor) => {
          const url = anchor.getAttribute('href')
          if (!url) return

          // Check if the link is internal (same origin or relative path)
          const isInternal = url.startsWith(window.location.origin) || url.startsWith('/')
          if (!isInternal) return

          // Remove target="_blank" for internal links
          anchor.removeAttribute('target')

          anchor.onclick = (e) => {
            if (e.metaKey || e.ctrlKey) return

            e.preventDefault()
            const path = url.replace(window.location.origin, '')
            this.$router.push(path)
          }
        })
      })
    }
  }
}
</script>
